/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Whtr_LowInputs */

const en_us2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waist-to-height under 0.40, which can point to being underweight. Worth raising with a health professional.`)
};

const pt_br2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relação cintura/altura abaixo de 0,40, o que pode indicar magreza excessiva. Vale conversar com um profissional de saúde.`)
};

const es_419_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación cintura/estatura por debajo de 0,40, lo que puede indicar bajo peso. Vale la pena hablarlo con un profesional de la salud.`)
};

const pt_pt2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relação cintura/altura abaixo de 0,40, o que pode indicar magreza excessiva. Vale a pena falares com um profissional de saúde.`)
};

const fr_fr2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport tour de taille/taille sous 0,40, ce qui peut indiquer une maigreur excessive. Parles-en à un professionnel de santé.`)
};

const de_de2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille-Größe-Verhältnis unter 0,40, was auf Untergewicht hindeuten kann. Sprich am besten mit einer Fachperson aus dem Gesundheitswesen darüber.`)
};

const it_it2_body_assessment_warning_whtr_low = /** @type {(inputs: Body_Assessment_Warning_Whtr_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporto vita/altezza sotto 0,40, che può indicare sottopeso. Vale la pena parlarne con un professionista della salute.`)
};

/**
* | output |
* | --- |
* | "Waist-to-height under 0.40, which can point to being underweight. Worth raising with a health professional." |
*
* @param {Body_Assessment_Warning_Whtr_LowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_whtr_low = /** @type {((inputs?: Body_Assessment_Warning_Whtr_LowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Whtr_LowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_whtr_low(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_whtr_low(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_whtr_low(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_whtr_low(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_whtr_low(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_whtr_low(inputs)
	return en_us2_body_assessment_warning_whtr_low(inputs)
});
export { body_assessment_warning_whtr_low as "body-assessment.warning.whtr_low" }